import React from 'react';
import { svg } from 'lib/svgList';
import ItensMenu from 'components/ItensMenu';
import TitleTab from 'components/TitleTab';
import OptionsMonitoring from 'components/OptionsMonitoring';
import OfflineTiles from 'components/OfflineTiles';
import * as S from './styled';

export default function Monitoring() {
	const data = [
		{
			id: 1,
			title: 'Monitoramento',
			subTitle: 'Meus Alertas',
			icon: svg.icon.warningOrange,
			content: <OptionsMonitoring type="alert" />
		},
		{
			id: 2,
			title: 'Monitoramento',
			subTitle: 'Meus Usos Tradicionais',
			icon: svg.icon.mapLocationOrange,
			content: <OptionsMonitoring type="traditionalUse" />
		},
		{
			id: 3,
			title: 'Monitoramento',
			subTitle: 'Meus Trajetos',
			icon: svg.icon.routeOrange,
			content: <OptionsMonitoring type="tracker" />
		},
		{
			id: 4,
			title: 'Monitoramento',
			subTitle: 'Onde estive / Localizações',
			icon: svg.icon.locationRoundOrange,
			content: <OptionsMonitoring type="whereIBeen" />
		},
		{
			id: 5,
			title: 'Monitoramento',
			subTitle: 'Minhas medidas',
			icon: svg.icon.routeDotOrange,
			content: <OptionsMonitoring type="measure" />
		},
		{
			id: 6,
			title: 'Tiles para uso offline',
			subTitle: 'Meus arquivos de tiles',
			icon: svg.icon.camadaLayerOrange,
			content: <OfflineTiles />
		}
	];

	return (
		<S.containerGeralMonitoring>
			<S.lineGray />
			<S.containerList>
				<TitleTab title="Monitoramento" />
				{data.map((item) => (
					<ItensMenu
						key={item.id}
						title={item.title}
						subTitle={item.subTitle}
						icon={item.icon}
						content={item.content}
					/>
				))}
			</S.containerList>
		</S.containerGeralMonitoring>
	);
}
